export enum ReceivedMessageType {
  directMessageSent = "directMessageSent",
  directMessageReceived = "directMessageReceived",
  threadMessageSent = "threadMessageSent",
  threadMessageReceived = "threadMessageReceived",
  threadMessageParentSent = "threadMessageParentSent",
  threadMessageParentReceived = "threadMessageParentReceived",
  notRelevant = "notRelevant",
}
